import { useAuthenticator } from '@aws-amplify/ui-react';
import { ThemeProvider } from 'styled-components';
import { ReactNode } from 'react';
import Icon from '../Icon/Icon';
import { IconKeys } from '../Icon/IconKeys';
import {
  LogoWrapper, SignInHeader, FooterWrapper, ResetPasswordHeaderWrapper,
} from './AmplifyLoginStyles';
import { BundleVersion } from '../../../featuresControl';
import { loginTheme } from '../../../theme/loginTheme';

function LoginTheme({ children }: { children: ReactNode }): JSX.Element {
  return <ThemeProvider theme={loginTheme}>{children}</ThemeProvider>;
}

function ResetPasswordPageHeader():any {
  const { toSignIn } = useAuthenticator();

  return (
    <LoginTheme>
      <ResetPasswordHeaderWrapper>
        <h2>Reset password</h2>
        <button
          type="button"
          onClick={toSignIn}
        >
          Back to login
        </button>
      </ResetPasswordHeaderWrapper>
    </LoginTheme>
  );
}

const LoginComponents = {
  Header() {
    return (
      <LoginTheme>
        <LogoWrapper>
          <Icon iconKey={IconKeys.LOGO} />
        </LogoWrapper>
      </LoginTheme>
    );
  },
  SignIn: {
    Header() {
      return (
        <LoginTheme>
          <SignInHeader>
            <h2>Welcome to Smart Mobility</h2>
            <p>Log in to start managing your fleet the smartest way possible.</p>
          </SignInHeader>
        </LoginTheme>
      );
    },
    Footer() {
      const { toResetPassword } = useAuthenticator();

      return (
        <LoginTheme>
          <FooterWrapper>
            <div className="forgot-password-row">
              <button
                type="button"
                onClick={toResetPassword}
              >
                Forgot password
              </button>
            </div>
            <div className="footer-meta">
              <p className="app-version">App version: {BundleVersion}</p>
              <p className="terms">
                By logging in, you agree to the <span>Terms of service</span> and <span>Privacy Policy</span>
              </p>
            </div>
          </FooterWrapper>
        </LoginTheme>
      );
    },
  },
  ResetPassword: {
    Header: ResetPasswordPageHeader,
  },
  ConfirmResetPassword: {
    Header: ResetPasswordPageHeader,
  },
  VerifyUser: {
    Footer() {
      setTimeout(() => {
        document.getElementsByTagName('input')[0].checked = true;
      });
      return <p />;
    },
  },
};

const formFields = {
  confirmResetPassword: {
    confirmation_code: {
      placeholder: 'Enter your confirmation code',
      label: 'Code',
      isRequired: true,
      type: 'text',
    },
    password: {
      placeholder: 'New Password',
      isRequired: true,
    },
    confirm_password: {
      placeholder: 'Confirm Password',
      isRequired: true,
    },
  },
};

export { LoginComponents, formFields };
